import { TextField } from "@mui/material";
import { memo } from "react";

const CustomTextField = ({ name, value, onChange = () => { }, onBlur = () => { }, variant = "outlined", placeholder, id = "outlined-multiline-flexible",rows=1,minLength,maxLength }) => {
    return (
        <TextField
            sx={{ width: "100%" }}
            value={value}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            id={id}
            placeholder={placeholder}
            multiline
            rows={rows}
            variant={variant}
            inputProps={{
                minLength: minLength || 0,
                maxLength: maxLength 
            }}
        />
    );
}

export default memo(CustomTextField)